import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { Toaster } from "@/components/ui/sonner";
import Splash from "@/components/Splash";
import "@/App.css";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import CreateRoom from "@/pages/CreateRoom";
import RoomLobby from "@/pages/RoomLobby";
import AuctionLive from "@/pages/AuctionLive";
import PlayersBrowser from "@/pages/PlayersBrowser";
import JoinByLink from "@/pages/JoinByLink";
import AdminListone from "@/pages/AdminListone";

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="p-10 text-center text-slate-400">Caricamento…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <Splash />
        <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/join/:code" element={<JoinByLink />} />
            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/rooms/new" element={<Protected><CreateRoom /></Protected>} />
            <Route path="/rooms/:id/lobby" element={<Protected><RoomLobby /></Protected>} />
            <Route path="/rooms/:id/live" element={<Protected><AuctionLive /></Protected>} />
            <Route path="/players" element={<Protected><PlayersBrowser /></Protected>} />
            <Route path="/admin/listone" element={<Protected><AdminListone /></Protected>} />
          </Routes>
          <Toaster richColors position="top-right" />
        </BrowserRouter>
      </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
